import React from 'react'
import { styled } from 'styled-components'
import { Block, Paragraph } from 'suomifi-ui-components'
import _ from 'lodash'
import BlockReason from 'todistukset-ui/src/vtj/components/blocked-announcement/BlockReason.enum'
import {
  blockReasonTitleKey,
  blockReasonContentKey,
} from 'todistukset-ui/src/vtj/components/blocked-announcement/BlockedAnnouncement.util'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

const ParagraphWithNewlines = styled(Paragraph)`
  white-space: pre-line;
  line-height: 1.33;
  margin-bottom: ${({ theme }) => theme.spacing.m};
`

interface BlockingAnnouncementProps {
  blockReason: BlockReason
}
const BlockedAnnouncement: React.FC<BlockingAnnouncementProps> = ({
  blockReason,
}) => {
  return (
    <Block
      variant={'div'}
      pt={'xxl'}
      data-test-id={`${_.kebabCase(blockReason)}-announcement`}
      type="info"
    >
      <p>
        <strong>
          <LocalizedString stringKey={blockReasonTitleKey(blockReason)} />
        </strong>
      </p>
      <ParagraphWithNewlines>
        <LocalizedString stringKey={blockReasonContentKey(blockReason)} />
      </ParagraphWithNewlines>
    </Block>
  )
}

export default BlockedAnnouncement
